import { appId, snowplowCloudfrontServer } from '@trello/config';
import { memberId } from '@trello/session-cookie';
import type { TrelloWindow, SnowplowConfig } from '@trello/window-types';
declare const window: TrelloWindow;

export const initialize = function () {
  if (!window.sp) {
    return;
  }

  const snowplow = window.sp;

  /*
   * Build snowplow configuration
   */
  const spConfig: SnowplowConfig = {
    appId: appId || 'web',
    cookieDomain: '.trello.com',
    respectDoNotTrack: true,
    stateStorageStrategy: 'cookie',
  };

  const isGdprUser = document.cookie.indexOf('gdpr-user=true') !== -1;
  const hasCookieConsent =
    document.cookie.indexOf('gdpr-cookie-consent=accepted') !== -1;

  if (isGdprUser && !hasCookieConsent) {
    spConfig.cookieLifetime = 0;
  }

  /*
   * Initialize snowplow library
   */
  snowplow('newTracker', 'cf', snowplowCloudfrontServer, spConfig);

  /*
   * Set user data
   */
  if (isGdprUser) {
    snowplow('setOptOutCookie', 'opt-out');
  }

  if (memberId) {
    snowplow('setUserId:cf', memberId);
  }
};
